<div class="fx-row fx-wrap">
        <div  style="height: 70px;  z-index: 10;">
            <gea-mes-header showLogOut="desktop" showMenu="both"></gea-mes-header>
        </div>    
</div> 
<div #apContainer> 
        <router-outlet (activate)="onActivate($event, apContainer)"></router-outlet>
</div>